import odata from 'odata-client';
import {
    GET_PROJECT_ACTIVITIES_REQUEST,
    GET_PROJECT_ACTIVITIES_ERROR,
    GET_PROJECT_ACTIVITIES_SUCCESS,
    TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';
/*import getToken from '../user/getToken';*/

export const tokenExpired = () => ({    
    type: TOKEN_EXPIRED
});

export const getProjectActivitiesRequest = () => ({
    type: GET_PROJECT_ACTIVITIES_REQUEST,
});

export const getProjectActivitiesError = errorOrResults => ({
    type: GET_PROJECT_ACTIVITIES_ERROR,
    error: errorOrResults.message,
});

export const getProjectActivitiesSuccess = payload => ({
    type: GET_PROJECT_ACTIVITIES_SUCCESS,
    payload,
});

export default (filterQuery) => async (dispatch, getState) => {
    dispatch(getProjectActivitiesRequest());

    const query = odata({service: getServiceUrl()}).resource(RESOURCES.ProjectActivities);
    query.select("ID,Name,Location,Address,SortOrder")
    query.expand(`${RESOURCES.Project}($select=ID)`)
    if (filterQuery !== undefined && filterQuery !== null) {
        query.filter(filterQuery);
    }

    const errorOrResult = await query.get({
        headers: {
            Authorization: `Bearer ${getState().user.token}`,
            ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('get project activity entries api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                const body = JSON.parse(res.body);
                const payload = body.value;
                const payloadObject = {}
                payload.forEach(obj => {
                    payloadObject[obj.ID] = obj
                })
                return payloadObject;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(getProjectActivitiesError(errorOrResult));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        dispatch(showNotification(errorOrResult.message, "error"))
        return;
    }

    dispatch(getProjectActivitiesSuccess(errorOrResult));

    return errorOrResult;
};